import { Drawer } from '@mui/material';
import { AnimatePresence } from 'motion/react';

import useSunrunShopStore, {
  useSunrunShopActions,
} from '@/data-store/hooks/useSunrunShopStore';

import useStyles from './Cart.styles';
import EmptyCart from './EmptyCart';
import FilledCart from './FilledCart';

const Cart: React.FC = () => {
  const { cart, isCartOpen } = useSunrunShopStore('cart', 'isCartOpen');
  const { setIsCartOpen } = useSunrunShopActions();
  const { classes } = useStyles();

  const handleClose = () => setIsCartOpen(false);
  const isEmpty = !cart?.lines.edges.length;

  return (
    <Drawer
      anchor='right'
      keepMounted
      open={isCartOpen}
      onClose={handleClose}
      PaperProps={{ className: classes.paper }}
    >
      <AnimatePresence mode='wait' initial={false}>
        {isEmpty ? <EmptyCart key='empty' /> : <FilledCart key='filled' />}
      </AnimatePresence>
    </Drawer>
  );
};

export default Cart;
